import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import userInfo from './modules/userInfo'
import getters from './getters'
import token from './modules/token'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    common,
    userInfo,
    token
  },
  getters
})

export default store
